<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(kpuRoles.readers)">
      <vx-card slot="no-body"  :title="$t('KPU.MainTitle')"  class="text-center greet-user" v-show="$auth.checkRoles(kpuRoles.readers)">
        <menu-control :items="projectTrackerItems"></menu-control>
      </vx-card>
    </div>

    <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(decarbonizationRoles.readers)">
      <vx-card slot="no-body"  :title="$t('Decarbonization.Title')"  class="text-center greet-user" v-show="$auth.checkRoles(decarbonizationRoles.readers)">
        <menu-control :items="decarbonizationItems"></menu-control>
      </vx-card>
    </div>
  </div>
</template>
<script>

import kpuRoles from './kpu/roles.js'
import decarbonizationRoles from './decarbonization/roles.js'
import cashflowRoles from './cashflowRoles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    menuControl
  },
  data() {
    return {
      kpuRoles,
      decarbonizationRoles,
      cashFlowItems : [ 
        {
          roles : cashflowRoles.collaborators,
          icon : "CalendarIcon",
          to : "/bsg/cashflow/projectLoms",
          i18nTitle : "CashFlow.ProjectLom.Title"
        },
        {
          roles : cashflowRoles.collaborators,
          icon : "CalendarIcon",
          to : "/bsg/cashflow/corporateLoms",
          i18nTitle : "CashFlow.CorporateLom.Title"
        },
        {
          roles : cashflowRoles.collaborators,
          icon : "FilmIcon",
          to : "/bsg/cashflow/compilations",
          i18nTitle : "CashFlow.Compilation.Title"
        },
        {
          roles : cashflowRoles.readers,
          icon : "BarChart2Icon",
          to : "/bsg/cashflow/reports/",
          i18nTitle : "CashFlow.Reports.Title"
        },
        {
          roles : cashflowRoles.collaborators,
          icon : "LayersIcon",
          to : "/bsg/cashflow/templates/",
          i18nTitle : "CashFlow.Template.Title"
        },
        {
          roles : cashflowRoles.collaborators,
          icon : "LockIcon",
          to : "/bsg/cashflow/admin/",
          i18nTitle : "CashFlow.Admin.Title"
        }
      ],
      projectTrackerItems : [ 
        {
          roles : kpuRoles.collaborators,
          icon : "BarChart2Icon",
          to : "/bsg/kpu/kpus",
          i18nTitle : "KPU.Title"
        },
        {
          roles : kpuRoles.readers,
          icon : "BarChart2Icon",
          to : "/bsg/kpu/report/kpu",
          i18nTitle : "KPU.Report"
        },
        {
          roles : kpuRoles.admins,
          icon : "FileTextIcon",
          to : "/bsg/kpu/report/paginatedkpu",
          i18nTitle : "KPU.PaginatedReport"
        },
        {
          roles : kpuRoles.readers,
          icon : "HelpCircleIcon",
          to : "https://agnicoeagle.sharepoint.com/:p:/s/GRP_CSD_Data_Solution/EUhXa2lSRldIk5_1ORLcF8kBW2JyCvQlrWbWbjJMCrVAKg?e=RTIVxH",
          i18nTitle : "Documentation"
        },
        {
          roles : kpuRoles.admins,
          icon : "LockIcon",
          to : "/bsg/kpu/admin/",
          i18nTitle : "KPU.Admin.Title"
        }
      ],
      decarbonizationItems: [
        {
          roles : decarbonizationRoles.admins,
          icon : "LockIcon",
          to : "/bsg/decarbonization/admin",
          i18nTitle : "Decarbonization.Admin.Title"
        },
        {
          roles : decarbonizationRoles.collaborators,
          icon : "BarChart2Icon",
          to : "/bsg/decarbonization/energyScenarios",
          i18nTitle : "Decarbonization.EnergyScenarios.Title"
        },
        {
          roles : decarbonizationRoles.readers,
          icon : "BarChart2Icon",
          to : "/bsg/decarbonization/report",
          i18nTitle : "Decarbonization.Report"
        }
      ]
    }
  }
};
</script>